import { render } from "./ComponentContener.vue?vue&type=template&id=014a23a1"
import script from "./ComponentContener.vue?vue&type=script&lang=js"
export * from "./ComponentContener.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__